/**
 * Tiny in-memory stale-while-revalidate cache for page data (the Insights
 * aggregates and the Traces list). It lets a page restore its last view
 * instantly when you toggle Insights <-> Traces, instead of flashing a skeleton
 * while it refetches (#1402 follow-up): the cached copy is shown immediately and
 * a background refetch keeps it fresh.
 *
 * Module-scoped (per tab), NOT sessionStorage — responses can be large and only
 * need to survive in-session navigation; a full refresh refetching is fine, and
 * we don't want to serialise big payloads. Callers build a key that already
 * includes the active impersonation domain, so a staff "view as customer" scope
 * never reads another scope's data.
 */
const store = new Map<string, unknown>();

/** Read a cached value, or `undefined` when nothing is stored for `key`. */
export function readRequestCache<T>(key: string): T | undefined {
  return store.get(key) as T | undefined;
}

/** Store (overwrite) the value for `key`. */
export function writeRequestCache<T>(key: string, value: T): void {
  store.set(key, value);
}

/** Drop everything. Used to isolate tests; not needed in app code. */
export function clearRequestCache(): void {
  store.clear();
}
